"use client"

import { useRef, useState } from "react";

type Props = {
  src: string;
  poster?: string;
};

export default function VideoPlayer({ src, poster }: Readonly<Props>) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [paused, setPaused] = useState(true);

  const play = () => {
    videoRef.current?.play();
  };

  return (
    <div className="relative w-full aspect-video bg-black overflow-hidden rounded-xl">
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        controls
        playsInline
        className="w-full h-full object-contain"
        onPlay={() => setPaused(false)}
        onPause={() => setPaused(true)}
      >
        <track kind="captions" />
      </video>

      {paused && (
        <div
          className="absolute inset-0 flex items-center justify-center cursor-pointer"
        >
          <button
            type="button"
            className="absolute inset-0 opacity-0"
            onClick={play}
          />
          <button
            type="button"
            onClick={play}
            className="flex size-20 items-center justify-center rounded-full shadow-lg cursor-pointer hover:scale-125 duration-300 z-10"
            style={{ backgroundColor: "#545BB8" }}
          >
            <img src="/assets/play-button.svg" alt="play" />
          </button>
        </div>
      )}
    </div>
  );
}